import { TSearchValue } from "@src/components/intelligence-search/search-template";
import { SmlAsset, SmlJsonQueryFilter } from "@src/types/intelligence-search";

export const convertSearchValuesToQueryFilter = (values: TSearchValue[]): SmlJsonQueryFilter[] => {
    return values.reduce((acc, curr) => {
        if (curr.name) {
            acc.push({
                name: curr.meta.name,
                meta: curr.meta as SmlAsset,
                isCustomMetric: curr.isCustomMetric,
            });
        }
        if (curr.filter) {
            acc.push({
                isCustomMetric: curr.isCustomMetric,
                name: curr.meta.name,
                operator: curr.filter.operator,
                values: curr.filter.value,
                meta: curr.meta as SmlAsset,
            });
        }
        return acc;
    }, [] as SmlJsonQueryFilter[]);
};
